// True inside the Capacitor (Android) app. Used by AdMob rewarded ads and the app-only UI.
const APP_UA_MARKER = 'AnimoraApp' // set by capacitor.config.ts -> appendUserAgent

export function isNativeApp(): boolean {
  if (typeof window === 'undefined') return false
  const cap = (window as any).Capacitor
  try {
    if (typeof cap?.isNativePlatform === 'function' && cap.isNativePlatform()) return true
    if (cap?.isNative === true) return true
  } catch { /* fall through to the user-agent marker */ }
  return typeof navigator !== 'undefined' && navigator.userAgent.includes(APP_UA_MARKER)
}

// Public Google Play listing of the Android app (shown on the website only, never inside the app).
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.animora.social'
